import { useContext, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { isProjectInIntegrationMode } from "utils/utils";
import { useProjectFeatureReportSummary } from "hooks/project";
import { Spin } from "antd";
import ErrorBoundary from "components/error-boundary";
import CiqLogPageHeader from "components/ciq-log-page-header";
import { useHistory, useParams } from "react-router";
import SubmittalRiskDetail from "./submittal-risk-detail";
import RiskSummary from "./risk-summary";
import MaterialRiskDetail from "./material-risk-detail";
import { RiskStates } from "constants/index";

function RiskReport() {
  const history = useHistory();
  const { projectId } = useParams() as any;

  const [selectedDetail, setSelectedDetail] = useState<null | {
    type: "submittal" | "material";
    risk: RiskStates.HIGH | RiskStates.MEDIUM | RiskStates.LOW;
  }>(null);

  const { projectDetails } = useContext(ProjectContext);

  const isIntegrationMode = isProjectInIntegrationMode(
    projectDetails ? projectDetails.mode : 0
  );

  const riskSummaryData = useProjectFeatureReportSummary();

  return (
    <div
      className="risk-report-page bg-white overflow-auto h-full w-full"
      data-testid="risk-report-page"
    >
      <CiqLogPageHeader
        entityName="Risk Report"
        items={[]}
        backButton={() => {
          history.push(`/project/${projectId}/reports/project-reports`);
        }}
        backButtonTestId="risk-report-back"
      />
      {riskSummaryData ? (
        <div>
          <ErrorBoundary>
            <RiskSummary
              onCountClick={setSelectedDetail}
              riskSummaryData={riskSummaryData}
              detailsClickEnabled
            />
          </ErrorBoundary>
          {selectedDetail ? (
            <div>
              {selectedDetail.type === "submittal" && (
                <ErrorBoundary>
                  <SubmittalRiskDetail
                    risk={selectedDetail.risk}
                    {...{
                      isIntegrationMode
                    }}
                    key={selectedDetail.risk}
                  />
                </ErrorBoundary>
              )}
              {selectedDetail.type === "material" && (
                <ErrorBoundary>
                  <MaterialRiskDetail
                    risk={selectedDetail.risk}
                    {...{
                      isIntegrationMode
                    }}
                    key={selectedDetail.risk}
                  />
                </ErrorBoundary>
              )}
            </div>
          ) : (
            <div className="flex justify-center">
              <div className="mt-40">
                Click within the table to get more details.
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="h-full flex items-center justify-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
}

export default RiskReport;
